import {AutoMap} from '@automapper/classes';

export abstract class TBaseGetAllResponseDto {
  @AutoMap()
  id!: string;

  @AutoMap()
  createdOn!: Date;
}

export abstract class TBaseGetResponseDto {
  @AutoMap()
  id!: string;
  @AutoMap()
  createdOn!: Date;
  @AutoMap()
  modifiedOn!: Date | null;
}

export abstract class TBaseLookupResponseDto {
  @AutoMap()
  id!: string;

  @AutoMap()
  name!: string;
}

export abstract class TBaseCreateResponseDto {
}

export abstract class TBaseUpdateResponseDto {
}

export abstract class TBaseDeleteResponseDto {

}

export abstract class TBaseBulkDeleteResponseDto {

}
